/* unplugin-vue-components disabled */import { render } from "./MyAccount.vue?vue&type=template&id=e0c42b10&scoped=true&ts=true"
import script from "./MyAccount.vue?vue&type=script&lang=ts"
export * from "./MyAccount.vue?vue&type=script&lang=ts"

import "./MyAccount.vue?vue&type=style&index=0&id=e0c42b10&lang=scss"
import "./MyAccount.vue?vue&type=style&index=1&id=e0c42b10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c42b10"]])

export default __exports__